import { z } from "zod";
import { VENUE_TYPES } from "../types/school.js";
import { httpUrl } from "./url.js";

// Validation schemas -- iteration 066 (unified school model)

// 131 Schools-as-Venues -- school admin adds a venue (verified=false until
// DugAds staff verify it).
export const addVenueSchema = z.object({
  name: z.string().min(1, "Name is required").max(200),
  venue_type: z.enum(VENUE_TYPES),
  google_place_id: z.string().max(255).nullish(),
  location: z.string().max(255).nullish(),
  latitude: z.number().min(-90).max(90).nullish(),
  longitude: z.number().min(-180).max(180).nullish(),
  abbreviation: z.string().max(50).nullish(),
  town: z.string().max(120).nullish(),
  province: z.string().max(120).nullish(),
});

export type AddVenueSchemaInput = z.infer<typeof addVenueSchema>;

// 085: hex colour (#RRGGBB, case-insensitive). Empty string coerced to null so the
// UI can clear a colour without special-casing.
const hexColor = z
  .string()
  .regex(/^#[0-9a-fA-F]{6}$/, "Colour must be a #RRGGBB hex value")
  .nullish()
  .transform((v) => (v === "" ? null : v));

export const createSchoolSchema = z.object({
  organization_id: z.string().min(1, "Organization is required"), // creates OrganizationSchool link
  school_type_id: z.string().max(4).nullish(),
  emis_number: z.string().max(50).nullish(),
  name: z.string().min(1, "Name is required").max(255),
  display_name: z.string().max(255).nullish(),
  abbreviation: z.string().max(255).nullish(),
  province: z.string().max(100).nullish(),
  town: z.string().max(100).nullish(),
  website_url: httpUrl(500).nullish(),
  google_place_id: z.string().max(255).nullish(),
  location: z.string().max(255).nullish(),
  latitude: z.number().min(-90).max(90).nullish(),
  longitude: z.number().min(-180).max(180).nullish(),
  primary_color: hexColor,
  secondary_color: hexColor,
});

export const updateSchoolSchema = z.object({
  school_type_id: z.string().max(4).nullish(),
  name: z.string().min(1, "Name is required").max(255).optional(),
  display_name: z.string().max(255).nullable().optional(),
  abbreviation: z.string().max(255).nullish(),
  province: z.string().max(100).nullish(),
  town: z.string().max(100).nullish(),
  website_url: httpUrl(500).nullish(),
  google_place_id: z.string().max(255).nullish(),
  location: z.string().max(255).nullish(),
  latitude: z.number().min(-90).max(90).nullish(),
  longitude: z.number().min(-180).max(180).nullish(),
  primary_color: hexColor,
  secondary_color: hexColor,
});

export type CreateSchoolInput = z.infer<typeof createSchoolSchema>;
export type UpdateSchoolInput = z.infer<typeof updateSchoolSchema>;
